var map = {
	"./X.svg": "f865",
	"./actions.svg": "24f8",
	"./add.svg": "eef4",
	"./arrow.svg": "b94f",
	"./back.svg": "ccfe",
	"./close.svg": "bf37",
	"./download.svg": "6369",
	"./email.svg": "9055",
	"./lens.svg": "8909",
	"./link.svg": "6bb3",
	"./linkedin.svg": "953d",
	"./location.svg": "a1fb",
	"./logout.svg": "309a",
	"./magic-wand.svg": "bdc8",
	"./mobile-bar.svg": "a7ed",
	"./mycontact.svg": "c899",
	"./phone.svg": "001e",
	"./qr-big.svg": "8696",
	"./qr-code.svg": "62a4",
	"./send-mail.svg": "c9e8"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "31e8";